import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import AlertBanner from "@/components/AlertBanner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import WhoWeHelp from "@/components/WhoWeHelp";
import Services from "@/components/Services";
import Pricing from "@/components/Pricing";
import HowItWorks from "@/components/HowItWorks";
import Team from "@/components/Team";
import SoftwareLogos from "@/components/SoftwareLogos";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";

const Home = () => (
  <div data-testid="home-page" className="bg-[#EAF4DD]">
    <AlertBanner />
    <Navbar />
    <main>
      <Hero />
      <WhoWeHelp />
      <Services />
      <Pricing />
      <HowItWorks />
      <Team />
      <SoftwareLogos />
      <CTASection />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        richColors
        toastOptions={{
          style: {
            fontFamily: '"DM Sans", system-ui, sans-serif',
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
